import {h, Fragment} from "preact"
import { useActions, useAppState, useProductFilters } from '@nosto/preact'
import { defaultConfig, sortOptions } from '../config'
import SelectedFilters from './SelectedFilters'
import SortBy from './SortBy'
import useArticlesBlogs from './useArticlesBlogs'

export default ({ toggleSidebar, sortByActive, toggleSortBy, changeResultsView, resultsView }) => {
    const { loading, query, response, pageType } = useAppState();
    const { updateSearch } = useActions();
    const { filters } = useProductFilters();
    const { resultArticlesBlogs } = useArticlesBlogs();

    const selectedFiltersCount =
        query.products?.filter?.reduce(
            (acc, curr) =>
                acc + (Array.isArray(curr.value) ? curr.value.length : 1),
            0
        ) ?? 0
    const docCount = response.products?.total ?? 0
    
    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find(
                    (v2) => v1.field === v2.field && v1.order === v2.order
                )
            )
        ) ?? defaultConfig.sort
    
    return (
        <>
            {/* MOBILE */}
            <div class={`mobile-toolbar hidden-lap-and-up ${resultsView && resultsView !== 'products' ? 'no-click' : ''}`}>
                <button type="button" onClick={toggleSidebar} class={`mobile-toolbar__item mobile-toolbar__item--filters ${filters.length > 0 ? 'has-filters' : ''}`}>
                    <svg focusable="false" width="16" height="16" class="icon icon--filters" viewBox="0 0 16 16"><path d="M0 4h16M0 12h16" fill="none" stroke="currentColor" stroke-width=""></path><circle cx="5" cy="4" r="2" fill="rgb(var(--background))" stroke="currentColor" stroke-width="1.2"></circle><circle cx="11" cy="12" r="2" fill="rgb(var(--background))" stroke="currentColor" stroke-width="1.2"></circle></svg>
                    <span class="mobile-toolbar__item-label">Filters</span>
                </button>
                <button type="button" onClick={toggleSortBy} class="mobile-toolbar__item mobile-toolbar__item--sort">
                    <span class="mobile-toolbar__item-label">Sort by</span>
                    <svg focusable="false" width="12" height="8" class="icon icon--chevron   " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>
                </button>
            </div>

            {/* GRID TOGGLES */}
            {resultsView && <div class="ns-view-toggles-container">
                <div class="ns-view-toggles-inner">
                    <button
                        class="ns-view-toggle"
                        type="button"
                        aria-expanded={resultsView === 'products'}
                        aria-controls="ns-products-view"
                        onClick={() => changeResultsView('products')}
                    >
                        Products
                    </button>
                    {/*<button 
                        class="ns-view-toggle"
                        type="button"
                        aria-expanded={resultsView === 'articles'}
                        aria-controls="ns-articles-view"
                        onClick={() => changeResultsView('articles')}
                    >
                        Articles &amp; Blogs
                    </button>*/}
                </div>
                <span class="ns-toggle-marker" data-view={resultsView}></span>
            </div>}

            {/* DESKTOP */}
            <div class='ns-header-controls' style={loading ? 'opacity: 0.3; justify-content: end !important;' : ''}>
                {resultsView === 'articles'
                    ?   <span class="ns-results"> {resultArticlesBlogs.length} results {pageType === 'search' && `for "${query.query}"`}</span>
                    :   pageType === 'search'
                        ?   <span class="ns-results" data-nosto-element="totalResults"> {docCount} {docCount === 1 ? "product" : "products"} for <b>"{query.query}"</b></span>
                        :   <span class="ns-results" data-nosto-element="totalResults"> {docCount} {docCount === 1 ? "product" : "products"}</span>
                }
                <SelectedFilters isMobile />
                <div class={`ns-desktop-sort hidden-pocket ${resultsView && resultsView !== 'products' ? 'no-click' : ''}`}>
                    <span class="product-facet__sort-by-title text--subdued">Sort by</span>
                    <button type="button" class="popover-button " onClick={toggleSortBy}>
                        <span>{activeSort.value.name}</span>
                        <svg focusable="false" width="12" height="8" class={`icon icon--chevron icon--inline ${sortByActive ? 'rotate' : ''}`} viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>
                    </button>
                </div>
                <SortBy
                    sortByActive={sortByActive}
                    toggleSortBy={toggleSortBy} />
            </div>

            
        </>
    )
}
